// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import TextImage from '../../../../assets/images/course-content-skipped-pic.svg';

const otherS = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
  `,
  InformationContainer: styled.div`
    width: 434px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
  `,
  Title: styled.div`
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #434343;
    max-width: 252px;
    font-style: italic;
  `,
  Overview: styled.div`
    margin-top: 18px;
    font: 16px Noto Sans TC;
    color: #434343;
  `,
  TextImage: styled.img.attrs({ src: TextImage, alt: 'text-image'})`
  `,
  Button: styled.a`
    margin-top: 46px;
    box-shadow: 0px 1px 4px 0px #00000040;
    width: 142px;
    cursor: pointer;
    height:44px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    font-size: 18px;
    line-height: 26px;
    color: #FFFFFF;
    background: #EF8200;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  `
};

export const S = {
  ...otherS
}
